import { SET_FILE, SET_COMPANY, SET_REUPLOAD_FILE } from "./bulkOrder.constant";

const initialState: bulkState = { file: [], companyId: "", reuploadFileData: { reUploadFlag: false, bulkOrderId: "" } };

export function bulkOrder(state = initialState, action: any): bulkState {
  switch (action.type) {
    case SET_FILE:
      return { ...state, file: action.payload };
    case SET_COMPANY:
      return { ...state, companyId: action.payload };
    case SET_REUPLOAD_FILE:
      return { ...state, reuploadFileData: action.payload };
    default:
      return state;
  }
}
